import { TimelineAttachmentContent } from '@/components/Timeline';
import {
  AddAttachmentTicketEvent,
  AddAttachmentPayload,
} from '@certhon/models';

interface AttachmentContentProps {
  event: AddAttachmentTicketEvent;
  onDownload?: (attachment: AddAttachmentPayload) => void;
  onOpenInLightbox?: (attachment: AddAttachmentPayload) => void;
}

export function AttachmentContent({
  event,
  onOpenInLightbox,
}: AttachmentContentProps) {
  const { payload } = event;

  return (
    <TimelineAttachmentContent
      checksum={payload.checksum}
      contentType={payload.contentType}
      size={payload.size}
      filename={payload.filename}
      onOpenInLightbox={onOpenInLightbox}
    />
  );
}
